import React, { useEffect, useState } from "react";
import { HiOutlinePaperClip } from "react-icons/hi2";
import { supportApi } from "../../api/support";
import { ISupportAttachment } from "../../data-access";
import { formatFileSize } from "./format";

interface IAttachmentImageProps {
  attachment: ISupportAttachment;
}

/**
 * The attachment endpoint needs the auth header, so the bytes are fetched and
 * handed to the <img> as an object URL. A plain src would come back 401.
 */
export const AttachmentImage = ({
  attachment,
}: IAttachmentImageProps): JSX.Element => {
  const [objectUrl, setObjectUrl] = useState<string>("");
  const [hasFailed, setHasFailed] = useState<boolean>(false);

  useEffect(() => {
    let isActive = true;
    let createdUrl = "";

    setObjectUrl("");
    setHasFailed(false);

    supportApi
      .getAttachmentBlob(attachment.id)
      .then((blob) => {
        if (!isActive) {
          return;
        }
        createdUrl = URL.createObjectURL(blob);
        setObjectUrl(createdUrl);
      })
      .catch(() => {
        if (isActive) {
          setHasFailed(true);
        }
      });

    return () => {
      isActive = false;
      if (createdUrl) {
        URL.revokeObjectURL(createdUrl);
      }
    };
  }, [attachment.id]);

  if (hasFailed) {
    return (
      <div className="support-attachment support-attachment--failed">
        <HiOutlinePaperClip size={16} />
        <span>{attachment.name}</span>
      </div>
    );
  }

  return (
    <div className="support-attachment">
      {objectUrl ? (
        <a href={objectUrl} target="_blank" rel="noopener noreferrer">
          <img src={objectUrl} alt={attachment.name} />
        </a>
      ) : (
        <div className="support-attachment__placeholder" />
      )}
      <div className="support-attachment__meta">
        {attachment.name} {formatFileSize(attachment.size)}
      </div>
    </div>
  );
};
